import axios from 'axios';
import React, { useEffect, useState } from 'react';

const Logo = () => {
  const style = {
    width: '60%',
    marginLeft: `2%`,
    height: '90%'
  };

  const[logo, setLogo] = useState('');

  const getLogo = () => {
    axios
      .get('api/logo/get')
      .then((response) => {
        setLogo(response.data);
      })
      .catch(function (error){
        console.log(error);
      });
  };

  useEffect(() => {
    getLogo();
  }, []);

  return (
    <div className="headerLogo">
      {logo && <img style={style} src={`data:image/jpg;base64, ${logo}`} alt="ci" />}
    </div>
  );
};

export default Logo;
